import { render } from "./ViolationsByConsentTypeChart.vue?vue&type=template&id=60fa6254&scoped=true"
import script from "./ViolationsByConsentTypeChart.vue?vue&type=script&lang=js"
export * from "./ViolationsByConsentTypeChart.vue?vue&type=script&lang=js"

import "./ViolationsByConsentTypeChart.vue?vue&type=style&index=0&id=60fa6254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fa6254"]])

export default __exports__